import { CodeBase } from "./_codeBase";

/** ビュー進捗表条件の進捗区分*/
export class ViewProgressConditionProgressDiv extends CodeBase<ViewProgressConditionProgressDiv>
{
    /** 進捗区分:"空", "　", "　"*/
    public static readonly A: ViewProgressConditionProgressDiv = new ViewProgressConditionProgressDiv("a", "　", "空");

    /** 進捗区分:"b", "新規", "○"*/
    public static readonly B: ViewProgressConditionProgressDiv = new ViewProgressConditionProgressDiv("b", "新規", "○");

    /** 進捗区分:"d", "完了", "●"*/
    public static readonly D: ViewProgressConditionProgressDiv = new ViewProgressConditionProgressDiv("d", "完了", "●");

    /** 進捗区分:"f", "中断", "△"*/
    public static readonly F: ViewProgressConditionProgressDiv = new ViewProgressConditionProgressDiv("f", "中断", "△");

    /** 進捗区分:"e", "完了見込", "▲"*/
    public static readonly E: ViewProgressConditionProgressDiv = new ViewProgressConditionProgressDiv("e", "完了見込", "▲");

    /** 進捗区分:"i", "キャンセル", "■"*/
    public static readonly I: ViewProgressConditionProgressDiv = new ViewProgressConditionProgressDiv("i", "キャンセル", "■");

    /** 進捗区分:"i", "キャンセル", "■"*/
    public static readonly Percent: ViewProgressConditionProgressDiv = new ViewProgressConditionProgressDiv("%", "パーセント", "%");

    /** 進捗区分:"c", "継続", "◎"*/
    public static readonly C: ViewProgressConditionProgressDiv = new ViewProgressConditionProgressDiv("c", "継続", "◎");

    /** 進捗区分:"h", "予定提出後に変更", "◇"*/
    public static readonly H: ViewProgressConditionProgressDiv = new ViewProgressConditionProgressDiv("h", "予定提出後に変更", "◇");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 機器指定の進捗区分リスト
     * @returns
     */
    public static getEquipmentProgressList() {
        return [
            ViewProgressConditionProgressDiv.B,
            ViewProgressConditionProgressDiv.F,
            ViewProgressConditionProgressDiv.E,
            ViewProgressConditionProgressDiv.I,
            ViewProgressConditionProgressDiv.Percent,
            ViewProgressConditionProgressDiv.C,
            ViewProgressConditionProgressDiv.H,
        ];
    }

    /**
     * 作業項目指定の進捗区分リスト
     * @returns
     */
    public static getWorkProgressList() {
        return [
            ViewProgressConditionProgressDiv.A,
            ViewProgressConditionProgressDiv.B,
            ViewProgressConditionProgressDiv.D,
            ViewProgressConditionProgressDiv.F,
            ViewProgressConditionProgressDiv.E,
            ViewProgressConditionProgressDiv.I,
            ViewProgressConditionProgressDiv.Percent,
            ViewProgressConditionProgressDiv.C,
            ViewProgressConditionProgressDiv.H,
        ];
    }
}
